
import type { RootState } from 'app/store';
import { SystemAdminAction, SystemAdminState } from '../types';

const initialState: SystemAdminState = {
  releaseInformations: []
};

const systemAdminReducer = (
  state = initialState,
  action: SystemAdminAction
): SystemAdminState => {
  switch (action.type) {
    case 'SET_RELEASE_INFORMATIONS':
      return {
        ...state,
        releaseInformations: action.payload
      }

    default:
      return state;
  }
};
export default systemAdminReducer

// Selectors

export const getReleaseInformations = (state: RootState) => state.systemAdmin.releaseInformations;